import { getAuthToken } from '@/utils/auth'
import { apis, getApiUrl } from '@/apis/business/api-config.js'
import { EditorToolItems as Tool } from '@/common/enumeration.js'

let baseUrl = process.env.BASE_URL
if (process.env.NODE_ENV !== 'development') {
  baseUrl = window.__env.publicPath
}

if (baseUrl && !baseUrl.endsWith('/')) {
  baseUrl = baseUrl + '/'
}

const configEditor = {
  startupFocus: true,
  toolbar: {
    items: [
      Tool.Bold,
      Tool.Italic,
      // Tool.StrikeThrough,
      Tool.Underline,
      Tool.Alignment,
      // Tool.Vertical,
      Tool.Mathtype,
      Tool.File,
      Tool.Table,
      Tool.Media,
      Tool.Link,
      // Tool.Vertical,
      Tool.Undo,
      Tool.Redo
      // 'emoji'
      // 'blankBox'
    ]
  },
  // cloudServices: {
  //   tokenUrl: () => new Promise((resolve, reject) => {
  //     const xhrResponse = getAuthToken()
  //     if (!xhrResponse) {
  //       console.log('No authorize detected')
  //     }
  //     return resolve('Bearer ' + xhrResponse)
  //   }),
  //   uploadUrl: getApiUrl(apis.FileAPI) + '/v1/files/upload-editor'
  // },
  link: {
    // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
    addTargetToExternalLinks: true
  },
  nnanhMathType: {
    titleLabel: 'Thêm công thức',
    itemsToolbar: [
      {
        dataWrite: '\\frac',
        imgUri: baseUrl + 'src/mathquill/image/phan_so.svg',
        title: 'Phân số'
      },
      {
        dataWrite: '^',
        imgUri: baseUrl + 'src/mathquill/image/luy_thua.svg',
        title: 'Lũy thừa'
      },
      {
        dataWrite: '\\times',
        imgUri: baseUrl + 'src/mathquill/image/dau_nhan.svg',
        title: 'Dấu nhân'
      }
    ],
    libScript: {
      styleCss: baseUrl + 'src/mathquill/mathquill.css',
      jqScript: baseUrl + 'src/jquery/jquery.min.js',
      mathScript: baseUrl + 'src/mathquill/mathquill.min.js'
    }
  },
  table: {
    contentToolbar: [
      'tableColumn',
      'tableRow',
      'mergeTableCells',
      'tableCellProperties',
      'tableProperties'
    ]
  },
  mention: {
    feeds: [
      {
        marker: '@',
        feed: []
        // itemRenderer: customItemRenderer
      }
    ]
  },
  mentionData: [
  ],

  mediaEmbed: {
    previewsInData: true
  },

  removePlugins: ['MediaEmbedToolbar']
}

// function customItemRenderer (item) {
//   const itemElement = document.createElement('span')

//   itemElement.classList.add('custom-item')
//   itemElement.id = `mention-list-item-id-${item.userId}`
//   itemElement.textContent = `${item.name} `
//   return itemElement
// }

export { configEditor }
